<template>
  <lsm-widget
    :title="t('shift.current_needs')"
    icon="fa-chart-line"
    :subtitle="t('shift.current_needs')"
    data-testid="current-need-widget"
  >
    {{ t('shift.current_needs_description') }}
    <template #buttons>
      <v-btn
        to="/currentneeds"
        color="primary"
        :text="t('setting.current_needs_view')"
      />
    </template>
  </lsm-widget>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import LsmWidget from './LsmWidget.vue';

const { t } = useI18n();
</script>
